import script from "./PhotoGallerySetup.vue?vue&type=script&setup=true&lang=js"
export * from "./PhotoGallerySetup.vue?vue&type=script&setup=true&lang=js"

import "./PhotoGallerySetup.vue?vue&type=style&index=0&id=42c8099e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42c8099e"]])

export default __exports__